<template>
  <div v-if="false"></div>
</template>

<script>
import GeoJSON from "ol/format/GeoJSON";
import Select from "ol/interaction/Select";
import VectorSource from "ol/source/Vector";
import ClusterSource from "ol/source/Cluster";
import { click } from "ol/events/condition";
import { getStyle, getClusterStyle } from "../../styles";

const geoJSON = new GeoJSON();

export default {
  name: "SelectInteraction",
  inject: ["map"],
  mounted() {
    this.select = new Select({
      condition: click,
      layers: (layer) => layer.get("selectable"),
      style: (feature) => {
        if (feature.get("features").length > 1) {
          return getClusterStyle(feature.get("features").length, true);
        }

        return getStyle(
          this.map,
          this.styleName,
          feature.get("features")[0],
          true
        );
      },
    });

    this.select.on("select", (e) => {
      const features = e.target.getFeatures().getArray();

      if (features.length === 0) {
        this.$emit("select", null);
        return;
      }

      if (
        features[0].get("features") &&
        features[0].get("features").length > 1 &&
        this.map.getView().getZoom() < 16
      ) {
        return this.$emit("zoom-to", {
          ...features[0].getProperties(),
          geometry: geoJSON.writeGeometryObject(features[0].getGeometry()),
        });
      }

      if (
        features[0].get("features") &&
        features[0].get("features").length === 1
      ) {
        const feature = features[0].get("features")[0];

        this.$emit("select", {
          ...feature.getProperties(),
          geometry: geoJSON.writeGeometryObject(feature.getGeometry()),
        });
      }
    });

    this.map.addInteraction(this.select);
  },
  unmounted() {
    this.map.removeInteraction(this.select);
  },
  props: {
    selected: Object,
    styleName: String,
  },
  watch: {
    selected(selected) {
      if (!selected) {
        this.select.getFeatures().clear();
        // Force a re-render of all layers to ensure the deselection is reflected
        this.map.getLayers().forEach((layer) => {
          const source = layer.getSource();
          if (
            source instanceof VectorSource ||
            source instanceof ClusterSource
          ) {
            source.changed(); // Trigger a refresh of the layer's features
          }
        });
        return;
      }

      this.map.getLayers().forEach((layer) => {
        const source = layer.getSource();
        if (source instanceof VectorSource) {
          const selectedFeature = source.getFeatureById(selected.id);
          if (selectedFeature) {
            this.select.getFeatures().push(selectedFeature);
          }
        }

        if (source instanceof ClusterSource) {
          const clusterFeatures = source.getFeatures();
          clusterFeatures.forEach((clusterFeature) => {
            const features = clusterFeature.get("features");
            if (features.length > 1) {
              return;
            }

            features.forEach((feature) => {
              if (feature.get("id") === selected.id) {
                this.select.getFeatures().push(clusterFeature);
              }
            });
          });
        }
      });
    },
  },
};
</script>

<style scoped></style>
